import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import apiPath from "../../utils/apiPath";
import { apiGet, apiPut } from "../../utils/apiFetch";
import useToastContext from "hooks/useToastContext";
import OFile from "components/reusable/OFile";
import helper from "../../utils/helpers";
import { BiArrowBack } from "react-icons/bi";
import ErrorMessage from "components/ErrorMessage";
import OButton from "components/reusable/OButton";
import { isEmpty } from "lodash";
import { validationRules } from "utils/constants";
const SellItemView = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [removedFiles, setRemovedFiles] = useState([]);
  const [uploadedImages, setUploadedImages] = useState(
    location?.state?.item?.images || null
  );
  const [uploadedVideos, setUploadedVideos] = useState(
    location?.state?.item?.videos || null
  );
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [editData, setEditData] = useState(location.state?.item);
  const [file, setFile] = useState([]);
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {},
  });

  const getBack = () => {
    setRedirect(true);
    if (location.state.from === 'list') {
      navigate("/marketplace-request-manager", { state: { from: 'list' } });
    } else {
      navigate("/marketplace-request-manager", { state: { from: 'request' } });
    }
  };

  const addMore = (item) => {
    handleFileUpload(item.target.files);
  };
  const remove = (index) => {
    if (index?.flag === 'fromApi') {
      const dbUrl = index?.url?.split("com/");
      const thumbnailUrl = !isEmpty(index?.thumbnail) ? index?.thumbnail?.split("com/") : '';
      setRemovedFiles([...removedFiles, { type: index?.type, url: dbUrl[1], thumbnail: thumbnailUrl[1] || '' }]);
    }
    setFile((prev) => {
      return prev.filter((res) => res !== index);
    });
  };
  const handleFileUpload = (e) => {
    for (let i = 0; i < e?.length; i++) {
      let getType = e[i].type.split("/");
      if (
        getType[1] !== undefined &&
        (getType[1] === "jpeg" ||
          getType[1] === "png" ||
          getType[1] === "jpg" ||
          getType[1] === "gif" ||
          getType[1] === "mp4")
      ) {
        setFile((prev) => {
          if (prev?.length > 0) {
            return [...prev, e[i]];
          } else {
            return [e[i]];
          }
        });
      } else {
        notification.error("Only jpeg,png,jpg,gif, mp4 formats are allowed");
      }
    }
  };

  const validate = () => {
    if (file?.length > 5) {
      notification.error("You cannot upload more than 5 files");
      return false;
    } else if (file?.length < 1) {
      notification.error("Please upload at least one image or video");
      return false;
    }
    return true;
  };

  var pressedKeys = []

  const onSubmit = async (data) => {
    try {
      let valid = validate();
      if (valid) {
        const path = apiPath.sellItemEdit + "/" + location?.state?.item?._id;
        const formData = new FormData();
        formData.append("itemName", data?.itemName);
        formData.append("itemBnName", data?.itemBnName);
        formData.append("itemPrice", data?.itemPrice);
        formData.append("category", data?.categoryId);
        formData.append("subCategory", data?.subCategoryId);
        formData.append("description", data?.description);
        formData.append("productType", data?.productType);
        formData.append("brand", data?.brand);
        formData.append("unit", data?.unit);
        formData.append("total", data?.total);
        formData.append("removedFiles", removedFiles?.length > 0 ? JSON.stringify(removedFiles) : JSON.stringify([]));
        if (file?.length > 0) {
          for (let i = 0; i < file?.length; i++) {
            formData.append("files", file[i]);
          }
        }
        const result = await apiPut(path, formData);
        if (result?.data?.success) {
          setRedirect(true);
          notification.success(result.data.message);
        } else {
          notification.error(result.data.message);
        }
      }
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
  };

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      setCategories(response?.docs);
    }
  };

  const getSubCategories = (categoryId) => {
    const category = categories.filter((item) => {
      return item?._id === categoryId;
    });
    setValue("subCategoryId", "")
    setSubCategories(category[0]?.subcategories);
  };

  const handleAmount = (e) => {
    var value = e.target.value;
    const pattern = /^\d{0,8}(\.\d{0,2})?$/
    if (e.target.value === '') {
      e.target.value = e.target.value.slice(e.target.value?.length - 1, -1)
    }
    const isValid = pattern.test(value)
    if (!isValid) {
      value = value.slice(0, -1)
    }
    setValue('itemPrice', value)
  }

  useEffect(() => {
    getCategories();
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue("itemName", editData.itemName ?? "");
      setValue("itemPrice", editData.itemPrice ?? "");
      setValue("categoryId", editData?.category ?? "");
      setValue("subCategoryId", editData?.subCategory ?? "");
      setValue("description", editData?.description ?? "");
      setValue("productType", editData?.productType ?? "");
      setValue("brand", editData?.brand ?? "");
      setValue("unit", editData?.unit ?? "");
      setValue("total", editData?.total ?? "");
      setValue("itemBnName", editData?.itemBnName ?? "");
      setFile(editData?.files);
    }
  }, [editData]);

  useEffect(() => {
    getSubCategories(editData?.category);
  }, [editData, categories.length]);

  if (is_redirect) {
    return navigate("/marketplace-request-manager");
  }
  console.log("errors", errors)
  const selectCategory = (value) => {
    console.log("valueeeeeeee",value)
  }
  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <span
          className="flex  items-center cursor-pointer"
          onClick={() => getBack()}
        >
          <BiArrowBack className="h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2" />
          <span className="ml-2">{t("O_BACK")}</span>
        </span>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className=""></div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="itemName"
                  id="itemName"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={51}
                  {...register("itemName", {
                    required: t("VALIDATION_ITEM_NAME_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_ITEM_NAME_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("itemName", value, { shouldValidate: true });
                  }}
                />

                <label
                  htmlFor="itemName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_ITEM_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.itemName?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="itemBnName"
                  id="itemBnName"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={51}
                  {...register("itemBnName", {
                    required: t("VALIDATION_ITEM_BN_NAME_REQUIRED"),
                    // validate: (value) => {
                    //   const val = value.trim();
                    //   return val.length < 3
                    //     ? t("VALIDATION_ITEM_BN_NAME_MIN_LENGTH")
                    //     : true;
                    // },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("itemBnName", value, { shouldValidate: true });
                  }}
                />

                <label
                  htmlFor="itemBnName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_ITEM_BN_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.itemBnName?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="categoryId"
                  name="categoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("categoryId", {
                    required: t("VALIDATION_SELECT_CATEGORY"),
                    onChange: (e) => {
                      getSubCategories(e.target.value);
                    },
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_CATEGORY")}
                  </option>
                  {categories &&
                    categories.length !== 0 &&
                    categories?.map(({ title, _id }) => (
                      <option
                        key={_id}
                        value={_id}
                        selected={_id === editData?.category}
                      >
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="name"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORY")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.categoryId?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="subCategoryId"
                  name="subCategoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("subCategoryId", {
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_SUB_CATEGORY")}
                  </option>
                  {subCategories &&
                    subCategories.length !== 0 &&
                    subCategories?.map(({ title, _id }) => (
                      <option
                        key={_id}
                        value={_id}
                        selected={_id === editData?.subCategory}
                      >
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="subCategoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_SUBCATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.subCategoryId?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="brand"
                  id="brand"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={51}
                  {...register("brand", {
                    required: t("VALIDATION_BRAND_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_BRAND_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("brand", value, { shouldValidate: true });
                  }}
                />

                <label
                  htmlFor="brand"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_BRAND")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.brand?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="productType"
                  id="productType"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={51}
                  {...register("productType", {
                    required: t("VALIDATION_PRODUCT_TYPE_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_PRODUCT_TYPE_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("productType", value, { shouldValidate: true });
                  }}
                />

                <label
                  htmlFor="productType"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_PRODUCT_TYPE")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.productType?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="string"
                  name="itemPrice"
                  id="itemPrice"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={8}
                  {...register("itemPrice", {
                    required: t("VALIDATION_ITEM_PRICE_REQUIRED"),
                    // pattern: {
                    //   value: validationRules.numbers,
                    //   message: t("INVALID_PRICE")
                    // },
                    onChange: (e) => handleAmount(e),
                    validate: value => {
                      return value === '0' ? t("PRICE_CANNOT_ZERO") : true
                    }
                  })}
                  onKeyDown={e => {
                    pressedKeys.push(e.key);
                    var lastKey = pressedKeys[pressedKeys.length - 2]
                    if (lastKey == '.') {
                      if (['-', '.', '+', 'e'].includes(e.key)) {
                        e.preventDefault()
                      }
                    } else if (['-', '+', 'e'].includes(e.key)) {
                      e.preventDefault()
                    }
                  }}
                // onChange={(event) => {
                //   var value = event.target.value;
                //   value = value.trimStart();
                //   setValue("itemPrice", value, { shouldValidate: true });
                // }}
                />

                <label
                  htmlFor="itemPrice"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_ITEM_PRICE")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.itemPrice?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="string"
                  name="unit"
                  id="unit"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={8}
                  {...register("unit", {
                    required: t("VALIDATION_UNIT_REQUIRED"),
                    pattern: {
                      value: validationRules.numbers,
                      message: t("INVALID_UNIT")
                    },
                    validate: value => {
                      return value === '0' ? t("UNIT_CANNOT_ZERO") : true
                    }
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("unit", value, { shouldValidate: true });
                  }}
                />

                <label
                  htmlFor="unit"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_UNIT")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.unit?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="string"
                  name="total"
                  id="total"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={8}
                  {...register("total", {
                    required: t("VALIDATION_TOTAL_REQUIRED"),
                    pattern: {
                      value: validationRules.numbers,
                      message: t("INVALID_TOTAL")
                    },
                    validate: value => {
                      return value === '0' ? t("TOTAL_CANNOT_ZERO") : true
                    }
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("total", value, { shouldValidate: true });
                  }}
                />

                <label
                  htmlFor="total"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_TOTAL") + ' (Kg/L)'}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.total?.message} />
              </div>
            </div>
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  type="text"
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("description", {
                    required: t("VALIDATION_DESCRIPTION_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_DESCRIPTION_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("description", value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.description?.message} />
              </div>
            </div>
            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
              <div className="text-center">
                <OButton
                  label={t("O_EDIT")}
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="mb-3">
              <div className="">
                <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                  {t("O_UPLOAD_IMAGES_VIDEOS")}
                  <span className="text-red-500">*</span>
                </h3>
              </div>
              <div className="flex relative text-center h-full items-baseline justify-center border border-dashed mb-5 rounded-sm p-[20px] min-h-[158px]">
                <input
                  className="absolute opacity-0 top-0 right-0 left-0 bottom-0 cursor-pointer"
                  type="file"
                  onChange={(e) => {
                    addMore(e);
                  }}
                  multiple
                  accept="image/png, image/jiffy, image/jpeg, image/jpg, video/mp4"
                  onClick={(e) => (e.target.value = null)}
                />
                <div className="flex flex-col items-center">
                  <img src="/images/photoupload.svg" className="mb-2" />
                  <strong>{t("ADD_MORE")}</strong>
                  <span style={{ fontSize: "14px", fontWeight: "500" }}>
                    {t("MAX_5_FILE_UPLOAD_TITLE")}
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap">
                {file?.length > 0 &&
                  file?.map((res, index) => {
                    return (
                      <div className="relative" key={index}>
                        <figure className="h-48 w-48 relative mr-5 mb-5">
                          {res?.type === "video" || res?.type === "video/mp4" ? (
                            <video
                              controls
                              className="w-full h-full object-cover"
                              src={
                                typeof res === "object" &&
                                  res?.flag !== "fromApi"
                                  ? URL.createObjectURL(res)
                                  : res?.url
                              }
                            />
                          ) : (
                            <img
                              className="w-full h-full object-cover"
                              src={
                                typeof res === "object" &&
                                  res?.flag !== "fromApi"
                                  ? URL.createObjectURL(res)
                                  : res?.url
                              }
                            />
                          )}
                          <a
                            href="javascript:void(0)"
                            onClick={() => remove(res)}
                            className="absolute top-3 right-3"
                          >
                            <img src="/images/photo-crose.svg" />
                          </a>
                        </figure>

                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellItemView;
